import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { SharedService } from '../../shared/shared.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FiltersService {

  constructor(
    private http: HttpClient
  ) { }

  getFilter(params: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${environment.api_server}/api/intelligent-filter`, params, { headers: SharedService.header, observe: 'response' });
  }

  getUsers(user: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${environment.api_server}/api/module/user/search/for/signal/simplified`, { username: user }, { headers: SharedService.header, observe: 'response' });
  }

  getSignalsUsers(params: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${environment.api_server}/api/module/user/signal/filter/list`, params, { headers: SharedService.header, observe: 'response' });
  }

  findDiagramByComponent(params: string): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${environment.api_server}/api/diagram/find-by-component`, params, { headers: SharedService.header, observe: 'response' });
  }

  getSignalById(id: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${environment.api_server}/api/module/admin/buffer/${id}`, { headers: SharedService.header, observe: 'response' });
  }

  getAllBanners(): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${environment.api_server}/api/banner/list`, {}, { headers: SharedService.header, observe: 'response' });
  }
}
